export default class itemsHelper {
  constructor(storageApi, summaryHelper) {
    this.storageApi = storageApi;
    this.summaryHelper = summaryHelper;
    this.items = null;
  }

  getAllCartItems() {
    if (this.items) {
      return this.items;
    } else {
      const items = {};
      const summary = this.summaryHelper.getItemsSummary();
      Object.keys(summary).forEach((uuid) => {
        const item = this.getCartItemFromStorage(uuid);
        if (item && item.uuid) {
          items[uuid] = item;
        }
      });
      this.items = items;
      return items;
    }
  }

  getCartItem(uuid) {
    const items = this.getAllCartItems();
    return items[uuid];
  }

  addCartItem(item) {
    const items = this.getAllCartItems();
    this.setCartItemInStorage(item);
    this.items = { ...items, [item.uuid]: item };
    return item;
  }

  removeCartItem(item) {
    const items = { ...this.getAllCartItems() };
    this.removeCartItemFromStorage(item);
    delete items[item.uuid];
    this.items = items;
    return item;
  }

  updateCartItem({ uuid, metadata, quantity }) {
    const items = this.getAllCartItems();
    const item = items[uuid];
    if (item) {
      const newItem = { ...item };
      metadata && (newItem.metadata = metadata);
      quantity && (newItem.quantity = quantity);
      this.setCartItemInStorage(newItem);
      this.items = { ...items, [uuid]: newItem };
    }
    return this.items;
  }

  setItemStatus(uuid, newStatus) {
    const items = this.getAllCartItems();
    const newItem = { ...items[uuid], status: newStatus };
    this.setCartItemInStorage(newItem);
    this.items = { ...items, [uuid]: newItem };
  }

  removeCartItemFromStorage(item) {
    this.storageApi.removeItem(item.uuid);
  }

  clearCartItemFromStorage(item) {
    this.storageApi.clear(item.uuid);
  }

  setCartItemInStorage(item) {
    this.storageApi.setItem(item.uuid, JSON.stringify(item));
  }

  getCartItemFromStorage(key) {
    const jsonItem = this.storageApi.getItem(key);
    return jsonItem && JSON.parse(jsonItem);
  }

  clearAll() {
    const summary = this.summaryHelper.getItemsSummary();
    Object.keys(summary).forEach((uuid) =>
      this.clearCartItemFromStorage({ uuid }),
    );
    this.items = null;
  }
}
